import { render } from "./MembershipLevelsPage.vue?vue&type=template&id=472d34b8"
import script from "./MembershipLevelsPage.vue?vue&type=script&lang=js"
export * from "./MembershipLevelsPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__